export default "__VITE_ASSET__DFsJ3$8t__"